import React from 'react';
import { motion } from 'framer-motion';
export function SolutionSection() {
  return <section className="py-16 lg:py-24 bg-[#FFF5F0]" data-id="element-71">
      <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8 text-center" data-id="element-72">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-73">
          <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-6" data-id="element-74">
            It's Not Your Fault — Here's What's Really Happening
          </h2>
          <p className="text-lg sm:text-xl text-slate-700 leading-relaxed" data-id="element-75">
            After 40, women experience a dramatic drop in metabolic rate. This
            means your body burns fewer calories, stores more fat — especially
            around the belly — and makes it nearly impossible to lose weight the
            traditional way. CitrusBurn™ was designed specifically for this.
          </p>
        </motion.div>
      </div>
    </section>;
}